import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { techFlow } from "@/mocks/criacao-sites";

export default function TechFlow() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="absolute inset-0 nx-grid opacity-20"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-300">
              <i className="ri-server-line" aria-hidden="true"></i>
              Estrutura completa
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold tracking-tight md:text-4xl">
              Seu site pode ter uma estrutura completa
            </h2>
            <p className="mt-4 text-base leading-relaxed text-background-200">
              Além do desenvolvimento, a NXHOST também oferece hospedagem, domínio, e-mail profissional,
              VPS e outras soluções para manter sua presença digital funcionando em uma estrutura
              integrada.
            </p>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-3">
            {techFlow.map((step, index) => (
              <div key={step.label} className="flex items-center gap-3">
                <div className="flex items-center gap-3 rounded-xl border border-background-50/10 bg-background-50/5 px-4 py-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500/15 text-primary-300">
                    <i className={`${step.icon} text-lg`} aria-hidden="true"></i>
                  </span>
                  <span className="whitespace-nowrap text-sm font-semibold text-background-100">
                    {step.label}
                  </span>
                </div>
                {index < techFlow.length - 1 ? (
                  <i
                    className="ri-arrow-right-line hidden text-lg text-background-500 md:block"
                    aria-hidden="true"
                  ></i>
                ) : null}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-10 flex justify-center">
            <Link
              to="/solucoes"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              Conhecer todas as soluções
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}